import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59365991"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "user-columns" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "columns-list p-text" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "columns-image" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "img-txt" }
const _hoisted_9 = { class: "txt p-text" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "note" }, "note", -1))
const _hoisted_11 = { class: "created-at" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "columns-image" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "img-txt" }
const _hoisted_16 = { class: "txt p-text" }
const _hoisted_17 = { class: "created-at" }
const _hoisted_18 = {
  key: 0,
  class: "user-columns-new-link"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "現在コラム情報の掲載はございません。", -1))
const _hoisted_20 = {
  key: 0,
  href: "/users/user_columns/new"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_subtitle = _resolveComponent("subtitle")!
  const _component_ColumnModal = _resolveComponent("ColumnModal")!
  const _component_infinite_loading_content = _resolveComponent("infinite-loading-content")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_subtitle, {
        icon: "f",
        text: "コラム"
      }),
      (!_ctx.enableInfiniteLoad)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "list",
            href: `/corporation/${_ctx.userAccountId}/user_columns`
          }, "一覧はこちら", 8, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ColumnModal, {
      column: _ctx.selectedColumn,
      visible: _ctx.isModalVisible,
      onCloseModal: _ctx.close
    }, null, 8, ["column", "visible", "onCloseModal"]),
    _createVNode(_component_infinite_loading_content, { onOnLoading: _ctx.onLoading }, {
      list: _withCtx(() => [
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, idx) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "columns-item",
              key: column.articleId
            }, [
              (column.isNote)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: column.link,
                    class: _normalizeClass(`test-column-item${idx}`),
                    target: "_blank"
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("img", {
                        src: _ctx.imageUrl(column),
                        alt: ""
                      }, null, 8, _hoisted_7)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("p", _hoisted_9, [
                        _createTextVNode(_toDisplayString(column.subTitle), 1),
                        _hoisted_10
                      ]),
                      _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.showSendDate(column.modified)), 1)
                    ])
                  ], 10, _hoisted_5))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: "",
                    onClick: ($event: any) => (_ctx.select($event, column)),
                    class: _normalizeClass(`test-column-item${idx}`)
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("img", {
                        src: _ctx.imageUrl(column),
                        alt: ""
                      }, null, 8, _hoisted_14)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("p", _hoisted_16, _toDisplayString(column.subTitle), 1),
                      _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.showSendDate(column.modified)), 1)
                    ])
                  ], 10, _hoisted_12))
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["onOnLoading"]),
    (!_ctx.columns.length && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _hoisted_19,
          (_ctx.isCurrentUserPage)
            ? (_openBlock(), _createElementBlock("a", _hoisted_20, "コラム情報の登録はこちら"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}